import React, { Component, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import MyChargers from "components/myChargers";
import SignIn from "components/authentication/signin";
import AOS from "aos";
import { isMobile } from "react-device-detect";
import MyFleet from "components/myFleet";
import reports from "components/reports";
import settings from "components/settings";
import myAccount from "components/myAccount";
import TripAndChargeSchedule from "components/TripAndChargeSchedule";

import "aos/dist/aos.css";
import "./App.css";
import "./fonts.css";

import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";
import forgetPass from "components/authentication/forgetPassword";
import forceResetPassword from "components/authentication/forceResetPassword";
import MailSent from "components/authentication/mailSent";
import NewPassword from "components/authentication/newPassword";
import Registration from "components/authentication/registration";
import PasswordSuccess from "components/authentication/passwordSuccess";
import PrivateRoute from "components/authentication/privateRoutes";
import { getRequest } from "services/axiosBaseClient";
import OtpVerifiedRoute from "components/authentication/otpVerifiedRoute";
import Loader from "components/common/Loader";

Amplify.configure(awsconfig);

const App = () => {
  useEffect(() => {
    setTimeout(() => {
      AOS.init({
        offset: isMobile ? 10 : 100,
      });
      AOS.refresh();
    }, 1500);
  }, []);

  return (
    // <SignIn></SignIn>
    <>
      <Loader />
      <Router hashType="noslash" basename={process.env.BASE_PATH}>
        <></>
        <Switch>
          <Route exact path="/" component={SignIn} />
          <PrivateRoute exact path="/myFleet" component={MyFleet} />
          <PrivateRoute exact path="/myChargers" component={MyChargers} />
          <PrivateRoute exact path="/reports" component={reports} />
          <PrivateRoute exact path="/settings" component={settings} />
          <PrivateRoute exact path="myAccount" component={myAccount} />
          <Route exact path="/signin" component={SignIn} />
          <Route exact path="/forgotPassword" component={forgetPass} />
          <Route
            exact
            path="/forceResetPassword"
            component={forceResetPassword}
          />
          <PrivateRoute exact path="/mailSent" component={MailSent} />
          <OtpVerifiedRoute exact path="/newPassword" component={NewPassword} />
          <PrivateRoute exact path="/registration" component={Registration} />
          <OtpVerifiedRoute
            exact
            path="/passwordSuccess"
            component={PasswordSuccess}
          />
          <PrivateRoute
            exact
            path="/TripAndChargeSchedule"
            component={TripAndChargeSchedule}
          />
        </Switch>
      </Router>
    </>
  );
};

export default App;
